import React from 'react';
import Loading from './Loading';

const WithLoading = (Component, LoadingComponent = Loading) => ({ isLoading, ...props }) => {
  if (!isLoading) return (<Component {...props} isLoading={isLoading} />);
  return (<LoadingComponent />);
};

export default WithLoading;



// WEBPACK FOOTER //
// ./src/components/WithLoading.js